import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

export const firebaseConfig = {
    apiKey: "AIzaSyB_TeNMvoQfsXda0rMuJ1oSBRBmWGKB4ek",
    authDomain: "thinking-of-u-prod.firebaseapp.com",
    projectId: "thinking-of-u-prod",
    storageBucket: "thinking-of-u-prod.firebasestorage.app",
    messagingSenderId: "600002059480",
    appId: "1:600002059480:web:c955eef30e62e121638bad",
    measurementId: "G-YB3HZJS3NM",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const functions = getFunctions(app);
const db = getFirestore(app);

let analytics = null;

// Detect local/dev contexts. Covers localhost, the loopback IP (127.0.0.1, ::1),
// and accessing a dev server over the LAN (e.g. 192.168.x.x / 10.x phone testing)
// so the emulators are used in every non-production context — not just "localhost".
const hostname = (typeof location !== "undefined" && location.hostname) || "";
const isLoopback = hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
const isPrivateLan = /^(10\.|127\.|192\.168\.|172\.(1[6-9]|2[0-9]|3[0-1])\.)/.test(hostname) ||
    hostname.endsWith(".local");
const isLocalDev = isLoopback || isPrivateLan;

// When running in any local/dev context, point to the emulators.
if (isLocalDev) {
    connectFirestoreEmulator(db, hostname, 9202);
    connectAuthEmulator(auth, `http://${hostname}:9200`, { disableWarnings: true });
    connectFunctionsEmulator(functions, hostname, 9201);
} else if (typeof window !== "undefined") {
    // Analytics is only initialized in real production — never against emulators
    // or any local/dev host. The `window` guard keeps non-browser contexts
    // (SSR/tests) from throwing when getAnalytics runs.
    analytics = getAnalytics(app);
}

export { app, auth, functions, db, analytics };
